// src/services/ClienteService.js

const API = '/api/clientes';

/**
 * Obtiene todos los clientes de la base de datos.
 * @returns {Promise<Array>} Lista de clientes
 */
export const getClientes = async () => {
  try {
    const response = await fetch(API, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Error al obtener la lista de clientes");
    }

    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 * Guarda un nuevo cliente en la base de datos.
 * @param {Object} clienteData - Datos del formulario
 */
export const guardarCliente = async (clienteData) => {
  try {
    const response = await fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(clienteData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Error al registrar el cliente");
    }

    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 * Actualiza un cliente existente.
 * @param {Object} clienteData
 */
export const actualizarCliente = async (clienteData) => {
  try {
    const response = await fetch(API, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(clienteData)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Error al actualizar el cliente");
    }

    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 * Elimina un cliente por ID.
 * @param {number} id
 */
export const eliminarCliente = async (id) => {
  try {
    const response = await fetch(`${API}?id=${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Error al eliminar el cliente");
    }

    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};